export const healthProfessionalDelimitationPrefixes = {
  healthUnit: 'healthUnit:',
  healthTeam: 'healthTeam:',
} as const

export type HealthProfessionalDelimitationScopeType =
  | 'municipality'
  | 'healthUnit'
  | 'healthTeam'

export interface ParsedHealthProfessionalDelimitationKey {
  scopeType: HealthProfessionalDelimitationScopeType
  value: string | null
}

function normalizeDelimitationValue(value: string | null): string | null {
  if (!value) {
    return null
  }

  const normalizedValue = value.trim()
  return normalizedValue.length > 0 ? normalizedValue : null
}

export function parseHealthProfessionalDelimitationKey(
  delimitationKey?: string | null,
): ParsedHealthProfessionalDelimitationKey {
  const normalizedKey = normalizeDelimitationValue(delimitationKey ?? null)
  if (!normalizedKey) {
    return {
      scopeType: 'municipality',
      value: null,
    }
  }

  if (normalizedKey.startsWith(healthProfessionalDelimitationPrefixes.healthTeam)) {
    return {
      scopeType: 'healthTeam',
      value: normalizeDelimitationValue(
        normalizedKey.slice(healthProfessionalDelimitationPrefixes.healthTeam.length),
      ),
    }
  }

  if (normalizedKey.startsWith(healthProfessionalDelimitationPrefixes.healthUnit)) {
    return {
      scopeType: 'healthUnit',
      value: normalizeDelimitationValue(
        normalizedKey.slice(healthProfessionalDelimitationPrefixes.healthUnit.length),
      ),
    }
  }

  // Backward compatibility: old values had only CNES in delimitationKey.
  return {
    scopeType: 'healthUnit',
    value: normalizedKey,
  }
}

export function buildHealthProfessionalUnitDelimitationKey(cnes: string): string {
  return `${healthProfessionalDelimitationPrefixes.healthUnit}${cnes}`
}

export function buildHealthProfessionalTeamDelimitationKey(ine: string): string {
  return `${healthProfessionalDelimitationPrefixes.healthTeam}${ine}`
}
